<!-- bizitravelonlineaktarim.vue -->
<template>
    <div id="app">
      <yetkidialog ref="yetkidialog"></yetkidialog>
      <hatadialog ref="hatadialog"></hatadialog>

      <v-app id="inspire" light>
        <v-card color="grey lighten-5" flat>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-toolbar size="120px" dark color="info">
                <v-toolbar-title class="baslikfont">
                  <v-layout align-center>
                  
                   
                    BiziClick Online '{{ $t('Ticket-Transfer') }}

                  </v-layout>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-menu offset-y>
                  <v-btn slot="activator" dark icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                  <v-list>
                  
  
                  </v-list>
                </v-menu>
              </v-toolbar>
            </v-flex>
  
            <v-container fluid>
              <v-card color="grey lighten-5" flat>
                <v-layout row wrap>
  
                 <v-flex xs12 sm6 md3>
  <v-form ref="formtarih" v-model="valid" lazy-validation>
    <tarihcomp
      :etiket="$t('Select-Date')"
      :detaygizle="false"
      v-model="date"
      v-bind:defaultvalue="'ok'"
      :rules="[v => !!v || $t('Please-select-a-date')]"
    ></tarihcomp>
  </v-form>
</v-flex>
<v-flex xs12 sm4 md2>
  <v-layout align-center justify-start row fill-height>

    <v-badge color="white" :overlap="true">
      <template v-slot:badge>
        <v-icon
          v-if="internetSatis"
          large
          color="green"
        >
          check_circle_outline
        </v-icon>
      </template>

      <v-btn
        small
        fab
        color="info"
        dark
        @click="dialogfiltre = true"
      >
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-badge>

    <div v-if="load1" class="ml-3">
      <v-tooltip bottom>
        <v-btn
          slot="activator"
          small
          @click="biletaktar()"
          color="info"
          fab
          dark
        >
          <v-icon>reply_all</v-icon>
        </v-btn>

        <span>{{ $t('Transfer-Tickets') }}</span>
      </v-tooltip>
    </div>

  </v-layout>
</v-flex>

                 
                  <!-- <v-flex xs12 sm6 md2>
                    <v-text-field hide-details label="agencyno" v-model="agencyno"> </v-text-field>
                  </v-flex> -->
  
                  
                </v-layout>
              </v-card>
            </v-container>
  
            <v-layout row wrap>
              <v-flex xs12 sm6 md6>
                <v-toolbar size="120px" dark color="success">
                  <v-toolbar-title>{{$t('Transferred-Tickets')}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
                  </v-text-field>
                </v-toolbar>
                <v-card>
                  <v-data-table :headers="headers" :rows-per-page-items=[20,50] :loading="progress" :items="itemsok"
                    :search="search3">
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">{{ props.item.biletNo }}</td>
                        <td class="text-xs-left">{{ props.item.aciklama }}</td>
                        <v-btn icon class="mx-0" @click="git(props.item)">
                          <v-icon color="teal">search</v-icon>
                        </v-btn>
                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      {{ $t('No-records-searched-for', { value: search3}) }}
                    </v-alert>
                  </v-data-table>
                </v-card>
  
              </v-flex>
              <v-flex xs12 sm6 md6>
  
                <v-toolbar size="120px" dark color="red">
                  <v-toolbar-title>{{$t('Tickets-Not-Transferred')}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field flat="" solo-inverted="" hide-details v-model="search4" :label="$t('Search')" append-icon="search">
                  </v-text-field>
                </v-toolbar>
                <v-card>
                  <v-data-table :headers="headers" :rows-per-page-items=[20,50] :loading="progress" :items="itemsno"
                    :search="search4">
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">{{ props.item.biletNo }}</td>
                        <td class="text-xs-left">{{ props.item.aciklama }}</td>
                        <v-btn icon class="mx-0" @click="git(props.item)">
                          <v-icon color="teal">search</v-icon>
                        </v-btn>
                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      {{ $t('No-records-searched-for', { value: search4}) }}
                    </v-alert>
                  </v-data-table>
                </v-card>
              </v-flex>

              <v-dialog
  v-model="dialogfiltre"
  persistent
  max-width="400px"
>
  <v-card>
    <v-card-title>
      Filtre Seçimi
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text>
      <v-checkbox
        v-model="internetSatis"
        label="İnternet Satış Olarak Aktar"
        hide-details
      ></v-checkbox>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn
        flat
        color="blue darken-1"
        @click="dialogfiltre = false"
      >
        Kapat
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
  
              <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
              </v-snackbar>
            </v-layout>
            <v-dialog v-model="load" hide-overlay persistent width="400">
              <v-card color="primary" dark>
                <v-card-text>
                    {{ $t('Please-Wait') }} ...
                  <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-card>
      </v-app>
    </div>
  </template>
  
  <script>
    import auth from '../../../../api/auth'
    import tool from "../../coper/tools";
    import tarihcomp from "@/components/app/customcomp/tarihim"
    import logoo from '../../../../assets/control'
    import helpers from "@/components/app/customcomp/helpers.js"
    import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
    import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
    export default {
      data() {
        return {
          dizaynData: [],
          sayfayetki: {
            Screen: false,
            Update: false,
            Save: false,
            Delete: false,
            Status: false,
            Message: null,
            islem: 0,
          },
          valid: true,
          search: '',
          headers: [{
              text: this.$t('Ticket-No'),
              value: 'biletNo'
            },
            {
              text: this.$t('Status'),
              value: 'aciklama'
            }
          ],
        
          StartDate: null,
          EndDate: null,
          itemsok: [],
          itemsno: [],
          statecari: [],
          MasrafMerkezi: [],
          searchcari: '',
          dictionary: {
            custom: {
              masrafkodu: {
                required: () => this.$t('Please-choose')
              },
              tarihsec: {
                required: () => this.$t('Please-select-a-date')
              },
              tarihsec1: {
                required: () => this.$t('Please-select-a-date')
              },
            }
          },
          renk1: 'info',
          dialogfiltre: false,
          search4: null,
          date: null,
          airline:"",
          agencyno:"",
          internetSatis: false,
  
          menu: false,
          modal: false,
          dateFormatted: '',
          date2: null,
          menu2: false,
          dateFormatted2: '',
          modal2: false,
          loading: false,
          progress: false,
          items: [],
          load: false,
          load1: true,
          search3: '',
          butondurum: true,
          snackbar: false,
          y: 'top',
          x: 'right',
          mode: '',
          timeout: 6000,
          text1: '',
          tooltip: false,
          el: null,
        }
      },
      beforeRouteEnter(to, from, next) {
        next(vm => {
          vm.prevRoute = from.path
        })
      },
      beforeMount: beforeMount,
      components: {
        'tarihcomp': tarihcomp,
        yetkidialog,
        hatadialog
      },
      watch: {
        searchcari(val) {
          val && this.carigetir(val)
        }
      },
      mounted() {
        this.$validator.localize('en', this.dictionary)
        //this.el = this.$refs.fab.$el
        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
  
        if (this.sayfayetki.Status != true) {
  
          this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {
  
            if (sonuc == true) {
  
              if (this.prevRoute != null) {
                var url = '#' + this.prevRoute
  
                window.open(url, '_self')
              } else {
                var mainUrl = '#/'
                window.open(mainUrl, '_self')
              }
            } 
  
          });
        } 
  
      },
      methods: {
        HataYonetimi(response, request, baslik) {
      this.load = false;
      this.load1 = true;
      if (response.status === 500) {
        this.$refs.hatadialog.open(response, request, baslik);
      } else {
        this.text1 = "Service Unavailable -" + baslik;
        this.snackbar = true;
      }
    },
       
        getImgUrl(img) {
          return logoo.logoControl(img);
        },
        biletaktar: biletaktar,
       
        git: git
      }
    }
  
    function git(v) {
      if (v.bilet.BiletNo.length == 13) {
        var str = v.bilet.BiletNo.slice(3)
      } else {
        var str = v.bilet.BiletNo
      }
  
      var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + v.bilet.HavayoluKodu + '&biletno=' + str + '&ucustipi=' + v
        .bilet.UcusTipi
      window.open(url, '_blank')
    }
  
    function biletaktar() {
      if (this.$refs.formtarih.validate()) {
        this.load = true
        this.load1 = false
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          tarih: this.date,
          InternetSatis: this.internetSatis
        }
        tool.api_post(this, 'ArkmanTicketStream/BiziTravelOnlineStream', params).then((response) => {
  
          var aktarilan = 0
          this.itemsok = []
          this.itemsno = []
  
          response.body.forEach(element => {
            if (element.aciklama == " - BASARILI. ") {
              this.itemsok.push(element)
              aktarilan = aktarilan + 1
            } else {
              this.itemsno.push(element)
            }
          });
          this.text1 = this.$t('total-of-ticket-transfers-completed',{value: aktarilan})
          this.snackbar = true
          this.load = false
          this.load1 = true
  
        }, (response) => {
          this.HataYonetimi(response, params, "Aktarım yapılamadı.");
        })
  
      }
  
    }

  
  
    function beforeMount() {
  
    }
  </script>
  
  <style>
  </style>